module.exports = __webpack_public_path__ + "static/media/milestone_spyglass.33912d01.svg";